import { ModalCloseButtonHandler } from './modalCloseButtonHandler/modalCloseButtonHandler'
import { ModalHandler } from './modalHandler/modalHandler'
import { ShowMoreComponent } from './showmore/showmore.component'
import { TooltipComponent } from './tooltip/tooltip.component'

import { FileDownloader } from '@/shared/fileDownloader/fileDownloader'
import { FlashMessageHandler } from '@/shared/flashMessageHandler/flashMessageHandler'

export default () => {
	const initAll = (reinit = false) => {
		initTippy(reinit)
	}

	const initTippy = (reinit = false) => {
		if (reinit) {
			TooltipComponent.destroy()
		}
		TooltipComponent.init()
		FileDownloader.init()
		ModalCloseButtonHandler.init()
		ShowMoreComponent.init()

		if (!reinit) {
			ModalHandler.init()
			FlashMessageHandler.init()
		}
	}

	return {
		initAll,
		initTippy,
	}
}
